class Cart {
    constructor(mainSelector, buttonBuy, selectors, url) {
        let defaultSelectors = {
            button: ".cart-btn",
            popup: ".cart-popup",
            delete: ".cart-popup__del",
            overlay: ".overlay"
        }

        let defaultUrl = {
            add: "index.php?route=checkout/cart/add",
            remove: "index.php?route=checkout/cart/remove",
            edit: "index.php?route=checkout/cart/edit",
            info: "index.php?route=common/cart/info",
            wishlist: "index.php?route=account/wishlist/add",
            compare: "index.php?route=product/compare/add",
        }

        this.selectors = Object.assign(defaultSelectors, selectors);
        this.url = Object.assign(defaultUrl, url);

        this.cart = document.querySelector(mainSelector);

        this.button = this.cart.querySelector(this.selectors.button);
        this.popup = this.cart.querySelector(this.selectors.popup);
        this.delete = this.cart.querySelectorAll(this.selectors.delete);
        this.overlay = this.cart.querySelector(this.selectors.overlay);

        // START fix text info btn cart
        this.formatCartInfo(this.cart.getAttribute('title').split(' '));
        // END fix tex info btn cart

        this.productsBtn = document.querySelectorAll(buttonBuy); //'.in-cart__buy'
        this.spinBoxEdit = document.querySelectorAll('.spin-box-edit');

        this.xhr = new XMLHttpRequest();

        this.event();
    }

    formatCartInfo = (arr) => {
        this.cartBtnQty = this.button.querySelector('.cart-btn__quantity--info');
        this.cartBtnQty.innerHTML = arr[0];
        this.cart.setAttribute('title', arr.join(' '));
    }

    // icon "added" on "add to cart" button
    checkedCard = (el) => {
        this.cart.querySelectorAll('.cart-popup__item-del a').forEach(e => {
            if (el.dataset.productName == e.dataset.productName)
                el.querySelector('.card__added').style.display = "inline";
        });
    }

    event() {
        this.button.addEventListener('click', (e) => {
            if (this.popup.classList.contains('active') && e.currentTarget.classList.contains('cart-btn')) {
                this.popup.classList.remove('active');
                this.overlay.classList.remove('cart-overlay');
            } else {
                this.popup.classList.add('active');
                this.overlay.classList.add('cart-overlay');

                if (this.popup.querySelector('.cart-empty')) {
                    this.popup.classList.add('cart-popup__empty');
                } else {
                    this.popup.classList.remove('cart-popup__empty');
                }
            }
        });

        // close popup cart outside
        this.overlay.addEventListener('click', () => {
            this.overlay.classList.remove('cart-overlay');
            this.popup.classList.remove('active');
        });

        // close popup cart push button
        const cartFooterClose = document.querySelector('.cart-header__close');
        if (cartFooterClose) {
            cartFooterClose.addEventListener('click', () => {
                this.overlay.classList.remove('cart-overlay');
                this.popup.classList.remove('active');
            });
        }

        if (this.productsBtn != null || this.spinBoxEdit) {

            // click spinBox
            this.spinBoxEdit.forEach(el => {
                el.querySelector('.spin-box__down').addEventListener('click', (e) => {
                    const input = el.querySelector('.spin-box__input');
                    this.edit(input.name, parseInt(input.value, 10) - 1);
                })

                el.querySelector('.spin-box__input').addEventListener('input', (e) => {
                    const input = el.querySelector('.spin-box__input');
                    this.edit(input.name, parseInt(input.value, 10));
                })

                el.querySelector('.spin-box__up').addEventListener('click', (e) => {
                    const input = el.querySelector('.spin-box__input');
                    this.edit(input.name, parseInt(input.value, 10) + 1);
                })
            })

            // click buttn add
            this.productsBtn.forEach(el => {

                // icon "added" on "add to cart" button
                this.checkedCard(el)

                el.addEventListener('click', (e) => {
                    const inCart = e.currentTarget.closest('.in-cart');
                    this.add(inCart.dataset.id, inCart.querySelector('.spin-box__input').value);

                    // icon "added" on "add to cart" button
                    e.currentTarget.closest('.in-cart').querySelector(' .card__added').style.display = "inline";
                });
            });

            // delete item in cart list
            this.cart.querySelectorAll('.cart-popup__item-del').forEach(el => {
                el.addEventListener('click', (e) => {
                    this.remove(
                        e.currentTarget.querySelector(this.selectors.delete).dataset.del,
                        e.currentTarget.querySelector(this.selectors.delete).dataset.productName
                    );
                });
            });
        }

        // @TODO maybe create new class... compare
        const compare = document.querySelectorAll('.card__compare');
        if (compare) {
            compare.forEach(e => {
                e.addEventListener('click', (e) => {
                    this.compare(e.currentTarget.closest('.in-cart').dataset.id)
                    e.currentTarget.innerHTML = '<i class="bi bi-bar-chart-fill"></i>'
                });
            });
        }

        // @TODO maybe create new class... wishlist
        const wishlist = document.querySelectorAll('.card__heart');
        if (wishlist) {
            wishlist.forEach(e => {
                e.addEventListener('click', (e) => {
                    this.wishlist(e.currentTarget.closest('.in-cart').dataset.id);
                    e.currentTarget.innerHTML = '<i class="bi bi-heart-fill"></i>'
                });
            });
        }

        // @TODO maybe create new class... cupon
        const buttonCupon = document.querySelector('#button-coupon');
        if (buttonCupon) {
            const cupon = document.querySelectorAll('input[name=\'coupon\']');
            buttonCupon.addEventListener('click', (e) => {
                this.cupon(encodeURIComponent(cupon.value))
            });
        }

        // @TODO maybe create new class... voucher
        const buttonVoucher = document.querySelector('#button-voucher');
        if (buttonVoucher) {
            const voucher = document.querySelectorAll('input[name=\'voucher\']');
            buttonVoucher.addEventListener('click', (e) => {
                this.voucher(encodeURIComponent(voucher.value))
            });
        }
    }

    add = (id, quantyty) => {
        const opt = document.querySelectorAll('.product-options input[type="radio"]:checked, .product-options input[type="checkbox"]:checked, .product-options select, .product-options textarea, .product-options input[type="text"]');

        // need on product page
        let redirect = (opt.length === 0) ? true : false;

        let param = "";

        opt.forEach(el => {
            if (el.selectedIndex != undefined) {
                // for select options
                if (el.selectedIndex > 0) {
                    param += "&" + el.name + "=" + el.value;
                }
            } else {
                param += "&" + el.name + "=" + el.value;
            }
        })
        let arg = 'product_id=' + id + '&quantity=' + quantyty + param;

        this.xhr.open('POST', this.url.add);
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            try {
                if (this.xhr.status == 200) {
                    const json = JSON.parse(this.xhr.response);

                    let errorHtml = document.querySelectorAll('div .text-danger');

                    if (json['redirect'] && redirect === true)
                        return window.location.assign(json['redirect']);

                    if (json["success"]) {

                        errorHtml.forEach(el => el.remove());
                        this.msg(json);

                        this.formatCartInfo(json["total"].split(' '));

                        this.load(this.cartToggle);
                    }

                    if (json['error']) {
                        if (json['error']['option']) {
                            // cler repeated error
                            errorHtml.forEach(el => { el.remove() });

                            // for (const [k, v] of Object.entries(json['error']['option'])) {}
                            Object.entries(json['error']['option']).forEach(([key, value]) => {
                                let element = document.querySelector('#input-option' + key).closest('div');
                                if (element != null) {
                                    element.insertAdjacentHTML('afterend', '<div class="text-danger">' + value + '</div>');
                                    this.msgError(value);
                                }
                            });
                        }
                    }
                } else {
                    console.log("Cart add. xhr error");
                }
            } catch (e) {
                console.log("Cart add. Server say:" + this.xhr.responseText);
            }
        }
        // let data = {"product_id": id,"quantity": quantyty}
        // console.log(JSON.stringify(data));
        this.xhr.send(arg);
    }

    remove = (id, name) => {
        this.xhr.open('POST', this.url.remove);
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            try {
                if (this.xhr.status == 200) {
                    const json = JSON.parse(this.xhr.response);

                    if (json["success"]) {

                        // icon "added" on "add to cart" button
                        this.productsBtn.forEach(el => {
                            if (name == el.dataset.productName)
                                el.querySelector(' .card__added').style.display = "none";
                        });

                        // Warning! First key mast be '0'
                        if (json["total"].split(' ')[0] == 0)
                            this.popup.classList.add('cart-popup__empty');

                        this.formatCartInfo(json["total"].split(' '));
                        return this.load(this.cartToggle);
                    }
                }
            } catch (e) {
                console.log("server error:" + e.description);
            }
        }

        this.xhr.send('key=' + id);
    }

    // update. not used.needed for the checkout page
    edit = (quantity, value) => {
        this.xhr.open('POST', this.url.edit);
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            try {
                if (this.xhr.status == 200) {
                    // @TODO update cart button (count product)
                    // this.button.querySelector('.text').textContent = json["total"];
                    // this.msg(json);
                    return this.load(this.cartToggle);
                }
            } catch (e) {
                console.log("server error:");
            }
        }

        if (!value) value = 1;

        this.xhr.send('&' + quantity + '=' + value);
    }

    cartToggle = (html) => {
        var doc = new DOMParser().parseFromString(html, "text/html");

        this.popup.innerHTML = doc.querySelector(this.selectors.popup).innerHTML;

        // close popup cart push button
        const close = this.popup.querySelector('.cart-header__close')
        if (close)
            close.addEventListener('click', () => {
                this.overlay.classList.remove('cart-overlay');
                this.popup.classList.remove('active');
            });

        // icon "added" on "add to cart" button
        this.cart.querySelectorAll('.cart-popup__item-del').forEach(el => {
            el.addEventListener('click', (e) => {
                this.remove(
                    e.currentTarget.querySelector(this.selectors.delete).dataset.del,
                    e.currentTarget.querySelector(this.selectors.delete).dataset.productName
                );
            });
        });
    }

    load = (callback) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', this.url.info);
        xhr.send();

        xhr.onload = (function (e) {
            return function () {
                if (xhr.readyState === XMLHttpRequest.DONE)
                    callback(e.response)
            }
        })(xhr);
    }

    // @TODO maybe create new class... wishlist
    wishlist = (id) => {
        this.xhr.open('POST', this.url.wishlist);
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        let status = false;

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            if (this.xhr.status == 200) {
                const json = JSON.parse(this.xhr.response);

                if (json["success"]) // think about it (login - logout)
                    this.msg(json);
            }
        }
        this.xhr.send('product_id=' + id);
    }

    // @TODO maybe create new class... compare
    compare = (id) => {
        this.xhr.open('POST', this.url.compare);
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            if (this.xhr.status == 200) {
                const json = JSON.parse(this.xhr.response);

                if (json["success"])
                    this.msg(json);
            }
        }
        this.xhr.send('product_id=' + id);
    }

    // @TODO maybe create new class... cupon
    cupon = (cuponValue) => {
        this.xhr.open('POST', 'index.php?route=extension/total/coupon/coupon');
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            if (this.xhr.status == 200) {
                const json = JSON.parse(this.xhr.response);

                if (json['redirect']) return window.location.assign(json['redirect']);

                if (json['error']) return this.msgError(json['error']);
            }
        }
        this.xhr.send('coupon=' + cuponValue);
    }

    // @TODO maybe create new class... voucher
    voucher = (voucherValue) => {
        this.xhr.open('POST', 'index.php?route=extension/total/voucher/voucher');
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            if (this.xhr.status == 200) {
                const json = JSON.parse(this.xhr.response);

                if (json['redirect']) return window.location.assign(json['redirect']);

                if (json['error']) return this.msgError(json['error']);
            }
        }
        this.xhr.send('voucher=' + voucherValue);
    }

    quote = () => {
        this.xhr.open('POST', 'index.php?route=extension/total/shipping/quote');
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        const data = 'country_id' + '&zone_id=' + '&postcode=' + '';

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            if (this.xhr.status == 200) {
                const json = JSON.parse(this.xhr.response);

                if (json['error']) {

                }
            }
        }
        this.xhr.send(data);
    }

    msg = (m) => {
        document.querySelector('.msg-container').insertAdjacentHTML('beforeend',
            `<div class="msg">
            <div class="msg-header">${m["total"]}</div>
            <div class="msg-body">${m["success"]}</div>
            </div>`
        );

        document.querySelectorAll('.msg').forEach(el => {
            setTimeout(function () { el.remove(); }, 3000);
        });
    }

    msgError = (m) => {
        document.querySelector('.msg-container').insertAdjacentHTML('beforeend',
            `<div class="msg msg__error">
            <div class="msg-body"><b>${m}</b></div>
            </div>`
        );

        document.querySelectorAll('.msg').forEach(el => {
            setTimeout(function () { el.remove(); }, 3000);
        });
    }

    // @TODO upload file on product page
    upload = () => { return; }
}
